import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import locale from "element-plus/es/locale/lang/zh-cn";
import * as ElementPlusIconsVue from "@element-plus/icons-vue"; //使用图标
import * as echarts from "echarts";
import { ElMessage } from "element-plus"; //由其他社区维护兼容vue3的 element-ui分支
import "element-plus/theme-chalk/dark/css-vars.css";
import "ol/ol.css";

const app = createApp(App);
app.config.globalProperties.$message = ElMessage; //这是全局挂载了原版element ui的this.$message()

app.use(ElementPlus, { locale });
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

app.use(store).use(router).mount("#app");
